import { fork } from 'redux-saga/effects';
import * as _ from 'lodash';
import createSaga from './create/create.saga';
import listSaga from './list/list.saga';
import editTypeSaga from './edit/edit.saga';

export default _.map([
    ...createSaga,
    ...listSaga,
    ...editTypeSaga,
]);

